import * as React from 'react';
import { NvRadioButton } from '@invitae/ids-react';
import styles from './ReflexConditions.module.esm.js';

var REFLEX_CONDITIONS = ['Regardless of initial results', 'Only if negative'];
var ReflexConditions = function (_a) {
    var selectedCondition = _a.selectedCondition, setCondition = _a.setCondition;
    var setConditionIfNotSelected = React.useCallback(function (condition) {
        if (condition !== selectedCondition) {
            setCondition(condition);
        }
    }, [selectedCondition, setCondition]);
    return (React.createElement("fieldset", { className: styles.root, "data-testid": "reflex-conditions" },
        React.createElement("legend", { className: styles.header }, "Under which conditions"),
        React.createElement("div", { className: styles.radioButtonsWrapper }, REFLEX_CONDITIONS.map(function (condition) { return (React.createElement("div", { className: styles.radioButton, "data-testid": "condition-".concat(condition), key: condition },
            React.createElement(NvRadioButton, { label: condition, onClick: function () { return setConditionIfNotSelected(condition); }, selected: condition === selectedCondition }))); }))));
};

export { REFLEX_CONDITIONS, ReflexConditions as default };
//# sourceMappingURL=ReflexConditions.esm.js.map
